import React, {useRef} from 'react';
import {motion} from 'motion/react';
import {SocialProofData} from '../mockData';
import {SocialProofItem} from '../shared/components/social-proof-item/social-proof-item.react-component';
import {ChipsOverlay} from '../shared/components/chip/compositions/chips-overlay/chips-overlay.react-component';
import {useScrollAnimation} from '../shared/hooks/use-scroll-animations';
import styles from './social-proof-desktop.module.scss';

export const SocialProofDesktop: React.FC = () => {
    const panelsRef = useRef<HTMLDivElement[]>([]);
    const {wrapperRef, containerRef, x, scrollYProgress, totalScrollHeight} = useScrollAnimation();

    return (
        <div
            className={styles['social-proof-scroll-area']}
            ref={wrapperRef as React.RefObject<HTMLDivElement>}
            style={{height: totalScrollHeight}}
        >
            <div
                className={styles['social-proof-sticky-container']}
                ref={containerRef as React.RefObject<HTMLDivElement>}
            >
                <div className={styles['social-proof-header']}>
                    <h2 className={styles['social-proof-title']}>
                        What hustlers are saying about Udemy
                    </h2>
                </div>

                <section className={styles['social-proof-wrapper']}>
                    <motion.div className={styles['social-proof-inner']} style={{x}}>
                        {SocialProofData.map((item, index) => (
                            <SocialProofItem
                                key={index}
                                item={item}
                                index={index}
                                variant="desktop"
                                styles={styles}
                                panelsRef={panelsRef}
                                scrollProgress={scrollYProgress}
                            />
                        ))}
                    </motion.div>
                </section>
                <ChipsOverlay scrollProgress={scrollYProgress} />
            </div>
        </div>
    );
};
